import { getCurrentAuthenticatedUser, useCurrentAuthenticatedUser } from './useCurrentAuthenticatedUser'

export const useIsAuthenticated = (): boolean => {
    const user = useCurrentAuthenticatedUser()

    if (user?.amplifyUser?.challengeName === 'NEW_PASSWORD_REQUIRED') {
        return false
    }

    const isAuthenticated = !!user

    return isAuthenticated
}

export const getIsAuthenticated = async (): Promise<boolean> => {
    const user = await getCurrentAuthenticatedUser()

    if (user?.amplifyUser?.challengeName === 'NEW_PASSWORD_REQUIRED') {
        return false
    }

    const isAuthenticated = !!user

    return isAuthenticated
}
